import { Timestamp } from "rxjs";

export function getDate(date: Date) {
    var _date = new Date(date);

    let dd = _date.getDate();
    let d = dd < 10 ? "0" + dd : dd;

    let mm = (_date.getMonth() + 1);
    let m = mm < 10 ? "0" + mm : mm;

    var mimi = _date.getMinutes();
    let mi = mimi < 10 ? "0" + mimi : mimi;

    var hh = _date.getHours();
    let h = hh < 10 ? "0" + hh : hh;

    return `${d}/${m}/${_date.getFullYear()}`;
}



export function getDateFromString(date: string) {
    var _date = new Date(date);

    let dd = _date.getDate();
    let d = dd < 10 ? "0" + dd : dd;

    let mm = (_date.getMonth() + 1);
    let m = mm < 10 ? "0" + mm : mm;

    var mimi = _date.getMinutes();
    let mi = mimi < 10 ? "0" + mimi : mimi;

    var hh = _date.getHours();
    let h = hh < 10 ? "0" + hh : hh;

    return `${d}/${m}/${_date.getFullYear()}`;
}

export function getDateTime(date: Date) {
    var _date = new Date(date);

    let dd = _date.getDate();
    let d = dd < 10 ? "0" + dd : dd;

    let mm = (_date.getMonth() + 1);
    let m = mm < 10 ? "0" + mm : mm;

    var mimi = _date.getMinutes();
    let mi = mimi < 10 ? "0" + mimi : mimi;

    var hh = _date.getHours();
    let h = hh < 10 ? "0" + hh : hh;

    return `${d}/${m}/${_date.getFullYear()} ${h}:${mi}`;
}

export function getToday() {
    let newDate = new Date();
    return new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate());
}

export const getTodayDateString = () => {
    let d = new Date();
    d.setDate(d.getDate());
    return getDateString(d);
}

export const getTwoWeeksAheadDateString = () => {
    let d = new Date();
    d.setDate(d.getDate() + 14);
    return getDateString(d);
}

export const getDateString = (date: Date) => {
    date = new Date(date);
    let yy = date.getFullYear();
    let mm = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
    let dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return `${yy}-${mm}-${dd}`;
}

export const getTimeFromDateTimeString = (dateTimeString: string) => {

    const [day, month, yearTime] = dateTimeString.split('/');
    const [year, time] = yearTime.split(' ');
    const [hours, minutes] = time.split(':');

    const dateObject = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10), parseInt(hours, 10), parseInt(minutes, 10));

    const extractedTime = dateObject.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });

    return extractedTime;

};

export const removeSecondsFromTime = (time: any) => {
    let formattedTime = time.substr(0, 5);
    return formattedTime;
}

export const getFormatedDate = (dateStr: string) => {
    if (!dateStr) return '';
    return dateStr.split('T')[0]; // Extracts '2025-06-06'
};

export const getDateStringNormalized = (date: Date, withTime?: boolean) => {
    if (!date) return;

    if (date instanceof Date !== true) {
        date = new Date(date);
    }

    let yy = date.getFullYear();
    let mm = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
    let dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

    var _return = `${dd}/${mm}/${yy}`;

    if (withTime) {
        let hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        let MM = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        return `${_return} ${hh}:${MM}`;
    }
    return _return;
}

export const getStringDateNormalized = (dateString?: string, withTime?: boolean) => {
    if (!dateString) return "";
    let date = new Date(dateString);
    return getDateStringNormalized(date, withTime);
}

export function get7DaysRange(): { dateFrom: string, dateTo: string } {
 const today = new Date(); 

  const from = new Date(today);
  from.setDate(from.getDate() - 6);

  return { dateFrom: getDateString(from) ,dateTo: getDateString(today) };
}